"use client";

export { default } from "./section/page";
